module.exports = __webpack_public_path__ + "img/corentin.87258d09.jpg";